import { useEffect, useState } from "react";

/**
 * Live viewport size for the floating-chat shells' fixed-position geometry.
 * Hand-rolled (not usehooks-ts `useWindowSize`) so the SSR/initial values stay
 * the ones the canvas panel has always used.
 */
export function useViewportSize(): {
  viewportWidthPx: number;
  viewportHeightPx: number;
} {
  const [viewportWidthPx, setViewportWidthPx] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth : 2000,
  );
  const [viewportHeightPx, setViewportHeightPx] = useState(() =>
    typeof window !== "undefined" ? window.innerHeight : 1000,
  );

  useEffect(() => {
    const onResize = () => {
      setViewportWidthPx(window.innerWidth);
      setViewportHeightPx(window.innerHeight);
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return { viewportWidthPx, viewportHeightPx };
}
